import { Badge, Tooltip } from "@mantine/core";
import { usePrinciples } from "../hooks/usePrinciples";

interface PrincipleBadgeProps {
  id: string;
  variant?: "filled" | "light" | "outline" | "default" | "dot";
  color?: string;
}

/**
 * Бейдж приёма Альтшуллера с тултипом-названием. Каталог приёмов кэшируется
 * один раз через TanStack Query — все Badge на странице берут из одного места.
 */
export function PrincipleBadge({ id, variant = "light", color }: PrincipleBadgeProps) {
  const { data } = usePrinciples();
  const info = data?.[id];
  const label = info ? `№${id}: ${info.name_ru}` : `№${id}`;

  return (
    <Tooltip label={label} withArrow openDelay={200}>
      <Badge variant={variant} color={color} style={{ cursor: "help" }}>
        №{id}
      </Badge>
    </Tooltip>
  );
}
